import React from 'react';
import { CheckCircle2, Shield, Phone } from 'lucide-react';
export function Hero() {
  return <section className="bg-white pt-12 pb-16 lg:pt-20 lg:pb-24 px-4 sm:px-6 lg:px-8" data-id="element-71">
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-12 gap-12 items-start" data-id="element-72">
        {/* Left Column: Copy */}
        <div className="lg:col-span-7 flex flex-col justify-center" data-id="element-73">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-red-50 text-red-700 text-sm font-semibold mb-6 w-fit border border-red-100" data-id="element-74">
            <span className="relative flex h-2 w-2" data-id="element-75">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75" data-id="element-76"></span>
              <span className="relative inline-flex rounded-full h-2 w-2 bg-red-500" data-id="element-77"></span>
            </span>
            Broken or Foggy Window? Free In-Home Estimates Available
          </div>

          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold text-navy-900 leading-tight mb-6 tracking-tight" data-id="element-78">
            Residential Glass Repair &{' '}
            <span className="text-brandBlue-600" data-id="element-79">
              Home Window Glass Replacement
            </span>{' '}
            in Southeast Michigan
          </h1>

          <p className="text-lg sm:text-xl text-slate-600 mb-8 leading-relaxed max-w-2xl" data-id="element-80">
            Broken window glass, foggy double-pane windows, failed seals, door
            glass, shower glass, mirrors, table tops or custom home glass?
            Kosin’s Glass provides expert residential glass repair and
            replacement with free in-home estimates, competitive pricing and
            warranty-backed workmanship.
          </p>

          <ul className="space-y-4 mb-8" data-id="element-81">
            {['Broken window repair, window pane replacement, insulated glass and foggy double-pane service', 'Replace the glass only when your existing window frames are still in good condition', 'Door glass, shower glass, custom mirrors, table tops, shelves, screens and decorative glass', 'Family-owned since 2000, serving Howell, Ann Arbor, Novi and Southeast Michigan'].map((bullet, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-82">
                <CheckCircle2 className="w-6 h-6 text-brandBlue-600 flex-shrink-0 mt-0.5" data-id="element-83" />
                <span className="text-slate-700 text-lg" data-id="element-84">{bullet}</span>
              </li>)}
          </ul>

          <div className="flex items-center gap-2 text-sm text-slate-500 bg-slate-50 p-3 rounded-lg w-fit border border-slate-100" data-id="element-85">
            <Shield className="w-4 h-4 text-emerald-600" data-id="element-86" />
            <span data-id="element-87">
              Your information is secure. Kosin’s Glass will never share your
              details.
            </span>
          </div>
        </div>

        {/* Right Column: Form */}
        <div className="lg:col-span-5 w-full max-w-md mx-auto lg:mx-0 lg:ml-auto" id="estimate-form" data-id="element-88">
          <div className="bg-white rounded-2xl shadow-card border border-slate-100 overflow-hidden" data-id="element-89">
            <div className="bg-brandBlue-600 px-6 py-4 text-center" data-id="element-90">
              <span className="inline-block bg-brandBlue-700 text-white text-xs font-bold uppercase tracking-wider py-1 px-2 rounded mb-2" data-id="element-91">
                Free In-Home Estimate
              </span>
              <h2 className="text-2xl font-bold text-white" data-id="element-92">
                Request a Residential Glass Quote
              </h2>
            </div>

            <div className="p-6 sm:p-8" data-id="element-93">
              <p className="text-sm text-slate-600 mb-6 text-center" data-id="element-94">
                Submit your details and a Kosin’s Glass team member will contact
                you to confirm your project, location, glass dimensions, photos
                and appointment availability.
              </p>

              <form className="space-y-5" onSubmit={e => e.preventDefault()} data-id="element-95">
                <div data-id="element-96">
                  <label htmlFor="fullName" className="block text-sm font-semibold text-navy-900 mb-1.5" data-id="element-97">
                    Full Name
                  </label>
                  <input type="text" id="fullName" placeholder="John Smith" className="w-full px-4 py-3 rounded-lg border border-slate-300 focus:ring-2 focus:ring-brandBlue-500 focus:border-brandBlue-500 transition-colors bg-slate-50 focus:bg-white" required data-id="element-98" />
                </div>

                <div data-id="element-99">
                  <label htmlFor="phone" className="block text-sm font-semibold text-navy-900 mb-1.5" data-id="element-100">
                    Phone Number
                  </label>
                  <input type="tel" id="phone" placeholder="(555) 123-4567" className="w-full px-4 py-3 rounded-lg border border-slate-300 focus:ring-2 focus:ring-brandBlue-500 focus:border-brandBlue-500 transition-colors bg-slate-50 focus:bg-white" required data-id="element-101" />
                </div>

                <div data-id="element-102">
                  <label htmlFor="email" className="block text-sm font-semibold text-navy-900 mb-1.5" data-id="element-103">
                    Email Address
                  </label>
                  <input type="email" id="email" placeholder="john@email.com" className="w-full px-4 py-3 rounded-lg border border-slate-300 focus:ring-2 focus:ring-brandBlue-500 focus:border-brandBlue-500 transition-colors bg-slate-50 focus:bg-white" required data-id="element-104" />
                </div>

                <button type="submit" className="w-full bg-brandBlue-600 hover:bg-brandBlue-700 text-white font-bold text-lg py-4 px-6 rounded-xl transition-colors shadow-md flex justify-center items-center gap-2 mt-2" data-id="element-105">
                  Request My Free Estimate{' '}
                  <span aria-hidden="true" data-id="element-106">&rarr;</span>
                </button>
              </form>

              <div className="mt-6 text-center" data-id="element-107">
                <a href="tel:5175457772" className="inline-flex items-center justify-center gap-2 text-navy-900 font-medium hover:text-brandBlue-600 transition-colors" data-id="element-108">
                  <Phone className="w-4 h-4" data-id="element-109" />
                  Prefer to call? Howell Service Center: 517-545-7772
                </a>
              </div>

              <p className="text-xs text-slate-400 text-center mt-4" data-id="element-110">
                We respect your privacy. Your details are safe with us.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}